import { render, staticRenderFns } from "./CompEvents.vue?vue&type=template&id=1d91875f&scoped=true"
import script from "./CompEvents.vue?vue&type=script&lang=js"
export * from "./CompEvents.vue?vue&type=script&lang=js"
import style0 from "./CompEvents.vue?vue&type=style&index=0&id=1d91875f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d91875f",
  null
  
)

export default component.exports